import { Center, Link, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";

const SUPPORT_EMAIL = "support@allfred.io";

export const UnpaidBanner = observer(function UnpaidBanner() {
  const { workspaceStore } = useStore();
  const message = workspaceStore.settings?.unpaidBannerMessage;

  if (!message) return null;

  return (
    <Center
      w="full"
      px="4"
      py="2"
      color="white"
      fontWeight="medium"
      bg="red.600"
      data-testid="unpaid-banner"
    >
      <Text textAlign="center">
        {message} <Trans>Already paid? Let us know here:</Trans>{" "}
        <Link
          color="white"
          fontWeight="bold"
          textDecoration="underline"
          _hover={{ color: "red.100" }}
          href={`mailto:${SUPPORT_EMAIL}`}
          data-testid="unpaid-banner-support-link"
        >
          {SUPPORT_EMAIL}
        </Link>
      </Text>
    </Center>
  );
});
